export const locales = ["INT", "NO"];
export const languages: HrefLang[] = ["en", "nb", "nn", "sv", "da"];

export const defaultLocale = "INT";
export const defaultLanguage: HrefLang = "en";

export const localeCookieName = "t_country";
export const languageCookieName = "t_locale";
export const languageHeaderName = "x-t-lang";
export const pathHeaderName = "x-t-path";

export const isLanguage = (value: unknown): value is HrefLang =>
  typeof value === "string" && (languages as readonly string[]).includes(value);
